import { useEffect, useRef } from 'react';
import useStore from '../store/useStore';
import { buildMonthSnapshot } from '../utils/buildMonthSnapshot';

/**
 * Auto-snapshots the current month's balance sheet on app open.
 * Runs once per session after data loads. Controlled by userSettings.autoSnapshotEnabled (default: true).
 */
export function useAutoSnapshot() {
  const loading = useStore((s) => s.loading);
  const autoSnapshotEnabled = useStore((s) => s.userSettings?.autoSnapshotEnabled ?? true);
  const ran = useRef(false);

  useEffect(() => {
    if (loading || ran.current || !autoSnapshotEnabled) return;
    ran.current = true;

    const state = useStore.getState();
    const { upsertBalanceSheetMonth } = state;
    const now = new Date();
    const monthKey = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;

    const snapshot = buildMonthSnapshot(monthKey, state);
    upsertBalanceSheetMonth(snapshot);

    if (import.meta.env.DEV) console.log('[AutoSnapshot] Saved', monthKey);
  }, [loading, autoSnapshotEnabled]);
}
